import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  dataEmpleado: [],
  themeMode: localStorage.getItem("themeMode") || "light", // Carga el tema desde localStorage
  tourTafiraCompleted: localStorage.getItem("tourTafiraCompleted") === "true",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      state.dataEmpleado = [];
    },
    setEmpleado: (state, action) => {
      state.dataEmpleado = action.payload.dataEmpleado;
    },
    toggleThemeMode: (state) => {
      state.themeMode = state.themeMode === "dark" ? "light" : "dark";
      localStorage.setItem("themeMode", state.themeMode); // Guarda el tema en localStorage
    },
    setTourTafiraCompleted: (state) => {
      state.tourTafiraCompleted = true;
      localStorage.setItem("tourTafiraCompleted", "true");
    },
  },
});

export const { setLogin, setLogout, setEmpleado, toggleThemeMode, setTourTafiraCompleted } =
  authSlice.actions;
export default authSlice.reducer;
